export const listInvites = (userID) => `query MyQuery {
  listInvites(filter: {createdByID: {eq: "${userID}"}}) {
    items {
      id
      phoneNumber
    }
  }
}`;

export default listInvites;